import { render, staticRenderFns } from "./NotificationCenterContainer.vue?vue&type=template&id=7494501b&scoped=true"
import script from "./NotificationCenterContainer.vue?vue&type=script&lang=js"
export * from "./NotificationCenterContainer.vue?vue&type=script&lang=js"
import style0 from "./NotificationCenterContainer.vue?vue&type=style&index=0&id=7494501b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7494501b",
  null
  
)

export default component.exports